import { useLocation } from 'react-router'

/* Returns true when the URL hash matches `#${elementId}`. */
export function useHashMatch(elementId: string): boolean {
  const { hash } = useLocation()
  return hash === `#${elementId}`
}

/*
 * Returns true when the URL hash deep-links to a timeline item with the given
 * resource ID, in either the canonical `#item-<id>` form or the legacy
 * `#comment-<id>` form.
 */
export function useTimelineItemHashMatch(itemId: string | undefined): boolean {
  const { hash } = useLocation()
  if (!itemId) {
    return false
  }
  return hash === `#item-${itemId}` || hash === `#comment-${itemId}`
}
